<template>
  <div class="blog-conversation">
    <div class="container">
      <h1 class="blog-title">
        {{ shopifyData.blogTitle }}
      </h1>

      <!-- Featured Article -->
      <div v-if="shopifyData.featuredArticle" class="featured-article">
        <img
          v-if="shopifyData.featuredArticle.image"
          :src="shopifyData.featuredArticle.image.src"
          :alt="shopifyData.featuredArticle.title"
          class="featured-image"
          loading="lazy"
          aria-hidden="true"
          aria-label="Featured Article Image"
          width="800"
          height="400"
        />
        <h2>{{ shopifyData.featuredArticle.title }}</h2>
        <p class="excerpt">
          {{ shopifyData.featuredArticle.excerpt }}
        </p>
        <a :href="shopifyData.featuredArticle.url" class="read-more">Read More</a>
      </div>

      <!-- Remaining Articles Grid -->
      <div class="articles-grid">
        <article v-for="article in shopifyData.articles" :key="article.id" class="article-card">
          <img
            v-if="article.image"
            :src="article.image.src"
            :alt="article.title"
            class="article-image"
            loading="lazy"
            aria-hidden="true"
            aria-label="Article Image"
            width="300"
            height="200"
          />
          <h3>{{ article.title }}</h3>
          <p class="excerpt">
            {{ article.excerpt }}
          </p>
          <a :href="article.url" class="read-more">Read More</a>
        </article>
      </div>

      <!-- Pagination -->
      <div v-if="shopifyData.pagination.totalPages > 1" class="pagination">
        <a
          v-if="shopifyData.pagination.hasPrevious"
          :href="shopifyData.pagination.previousUrl"
          class="pagination-link"
        >
          Previous
        </a>
        <span
          >Page {{ shopifyData.pagination.currentPage }} of
          {{ shopifyData.pagination.totalPages }}</span
        >
        <a
          v-if="shopifyData.pagination.hasNext"
          :href="shopifyData.pagination.nextUrl"
          class="pagination-link"
        >
          Next
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlogConversationPage',
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.blog-conversation {
  padding: 40px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.blog-title {
  text-align: center;
  margin-bottom: 40px;
  font-size: 2.5rem;
}

.featured-article {
  margin-bottom: 60px;
  text-align: center;
}

.featured-image {
  width: 100%;
  max-width: 800px;
  height: auto;
  margin-bottom: 20px;
  object-fit: cover;
}

.articles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
}

.article-card {
  border: 1px solid #eee;
  padding: 20px;
  border-radius: 8px;
}

.article-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  margin-bottom: 15px;
  border-radius: 4px;
}

.excerpt {
  color: #666;
  margin: 10px 0;
}

.read-more {
  display: inline-block;
  padding: 8px 20px;
  background-color: #000;
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  margin-top: 10px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.pagination-link {
  padding: 8px 16px;
  border: 1px solid #000;
  border-radius: 4px;
  text-decoration: none;
  color: #000;
}

.pagination-link:hover {
  background-color: #000;
  color: #fff;
}
</style>
